// src/routes/purchasingRoutes.tsx
import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

// Lazy Purchasing pages
const SuppliersPage = lazy(() => import('../modules/purchasing/SuppliersPage'));
const PurchaseOrdersPage = lazy(() => import('../modules/purchasing/PurchaseOrdersPage'));
const GoodsReceiptsPage = lazy(() => import('../modules/purchasing/GoodsReceiptsPage'));

const Fallback = <div style={{ padding: 16 }}>Loading Purchasing…</div>;

const withSuspense = (el: JSX.Element) => <Suspense fallback={Fallback}>{el}</Suspense>;

export function renderPurchasingRoutes(
  Protected: ({ children }: { children: JSX.Element }) => JSX.Element
): JSX.Element {
  return (
    <>
      <Route path="/purchasing/suppliers" element={withSuspense(<Protected><SuppliersPage /></Protected>)} />
      <Route path="/purchasing/purchase-orders" element={withSuspense(<Protected><PurchaseOrdersPage /></Protected>)} />
      <Route path="/purchasing/goods-receipts" element={withSuspense(<Protected><GoodsReceiptsPage /></Protected>)} />
    </>
  );
}

